import React, { useEffect, useState } from "react";
import { Col, Container, Nav, NavDropdown, Navbar, Offcanvas, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsPersonCircle } from "react-icons/bs";
import { NavigateFunction } from "react-router-dom";
import logoHome from "../../../dist/images/logo/logo-home.png";
import { AccountApiImpl, UserDataPanelWrapper } from "../../../modules";
import { SearchApi } from "../../../modules/search";
import { useAuth } from "../../../providers/AuthContext.tsx";
import { navbarLinks } from "./NavbarLinks";

export interface NavHeaderInterface {
  navigate: NavigateFunction;
  themeColor: string;
  SearchInput?: SearchApi;
}

export const NavbarHeader: React.FC<{ searchApi: SearchApi } & NavHeaderInterface> = ({
  navigate,
  themeColor,
  SearchInput
}) => {
  const { userData, handleLogout, setCallbackLogin } = useAuth();
  const isLoggedIn = userData.username !== "";
  const { t } = useTranslation('core');
  const accountApi = new AccountApiImpl(navigate);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [showUserProfilePanel, setShowUserProfilePanel] = useState<boolean>(false);

  const userInfo = {
    username: t('login'),
    image: '',
  };

  const handleClickLogin = () => {
    setCallbackLogin({ goBack: true, origin: "/home" });
    accountApi.loadLoginScreen();
  };

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => {
        const ismobile = window.innerWidth < 992;
        if (ismobile !== isMobile) setIsMobile(ismobile);
      },
      false
    );
  }, [isMobile]);

  const getSessionComponent = () => {
    let { username, image } = userData;
    if (username === "") {
      username = userInfo.username;
      image = userInfo.image;
    }

    return (
      <>
        <span className="me-2" onClick={username === t('login') ? handleClickLogin : () => { }}>{username}</span>
        {username !== t('login') && image !== "" ?
          <img
            alt={"Sua Foto"}
            src={image}
            className={"rounded-circle ms-2"}
            width={50}
            height={50}
            referrerPolicy="no-referrer"
          /> : <BsPersonCircle className="fs-3" onClick={username === t('login') ? handleClickLogin : () => { }} />}
      </>
    );
  };

  const NavContentUserArea = () => {
    return (
      <div className="d-none d-lg-inline-flex">
        {isLoggedIn ?
          <NavDropdown
            id="nav-dropdown-large"
            title={getSessionComponent()}
            menuVariant="dark"
            className="d-none d-lg-block"
          >
            <NavDropdown.Item
              onClick={() => navigate("/adm/dashboard")}
            >
              {t('subscriberPanel')}
            </NavDropdown.Item>
            <NavDropdown.Item
              onClick={() => setShowUserProfilePanel(true)}
            >
              {t('profile')}
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item
              onClick={async () => {
                const isSessionExists = await handleLogout();
                if (isSessionExists) navigate("/");
              }}
            >
              {t('logout')}
            </NavDropdown.Item>
          </NavDropdown>
          :
          getSessionComponent()}
      </div>
    );
  }

  const NavContentSideBar = () => {
    return (
      <Navbar expand={false} className="bg-body-tertiary d-lg-none">
        <Container fluid>
          <Navbar.Toggle aria-controls="offcanvasNavbar" />
          <Navbar.Offcanvas
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel">Montacar</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="text-end">
              {!isLoggedIn && (
                <NavDropdown.Item
                  className="mb-4"
                  style={{ color: "blue", fontWeight: "bold" }}
                  onClick={handleClickLogin}
                >
                  {t('login')}
                </NavDropdown.Item>
              )}

              {navbarLinks.map((links, index) => (
                <NavDropdown.Item
                  key={index}
                  href="#"
                  onClick={() => navigate(links.url)}
                  className="text-capitalize mb-3 d-sm-none d-md-none"
                >
                  {t(links.string)}
                </NavDropdown.Item>
              ))}

              {isLoggedIn && (
                <>
                  <NavDropdown.Item
                    className="mb-3"
                    onClick={() => navigate("/adm/dashboard")}
                  >
                    {t('subscriberPanel')}
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => setShowUserProfilePanel(true)}
                  >
                    {t('profile')}
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    style={{ color: "red", fontWeight: "bold", marginTop: 25 }}
                    onClick={async () => {
                      const isSessionExists = await handleLogout();
                      if (isSessionExists) navigate("/");
                    }}
                  >
                    {t('logout')}
                  </NavDropdown.Item>
                </>
              )}
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    );
  };


  const NavContent = () => {
    return (
      <>
        <Nav className="col me-auto">
          <Row className="w-100">
            <Col className="col-12">
              {SearchInput?.getSearchComponent()}
            </Col>
          </Row>
        </Nav>
        <Navbar.Brand
          className="m-2 nav-text-size"
          style={{ cursor: "pointer" }}
        >
          {<NavContentUserArea />}
        </Navbar.Brand >
        <UserDataPanelWrapper
          showModal={showUserProfilePanel}
          setShowModal={setShowUserProfilePanel}
        />
      </>
    );
  };

  return (
    <Navbar
      expand="lg"
      className={`pt-4 justify-content-end ${themeColor}
        ${isMobile ? "" : "mb-5"}`}
      style={{
        boxShadow: `${isMobile ? "" : "0 10px 10px #ecf0f1"}`,
      }}
    >
      <Container className="bg-white">
        <Navbar.Brand href="/" className="logo-text">
          <img alt="" src={logoHome} className="d-inline-block App-logo" />
        </Navbar.Brand>
        {<NavContent />}
        {<NavContentSideBar />}
        {SearchInput?.getSearchComponent(true)}
      </Container>
    </Navbar>
  );
}
